import { Typography } from "antd";
import { getIn } from "formik";

import styles from "./styles.module.css";

/**
 * The validation message for one field, rendered under that field.
 *
 * Forms used to report a failed save with a single toast — "لطفا فیلد ها را به
 * درستی تکمیل کنید" — which says something is wrong but not what or where. This
 * puts the message where the user is already looking.
 *
 * It waits for the field to be touched: showing every "این فیلد الزامی است" the
 * moment a create form mounts would paint the whole page red before the user
 * has typed anything. Pressing save touches every field with an error (see
 * `submitFormik`), which is what makes the messages appear on a blank form.
 */
const FieldError = ({ formik, name, error, touched, className = "" }) => {
  const message = error ?? getIn(formik?.errors, name);
  const isTouched = touched ?? getIn(formik?.touched, name);

  /* Yup reports an object or array for nested shapes; only a leaf message is
   * something we can render. */
  if (!isTouched || typeof message !== "string" || !message) return null;

  return (
    <Typography.Text
      type="danger"
      role="alert"
      className={`${styles.error} ${className}`.trim()}
    >
      {message}
    </Typography.Text>
  );
};

export default FieldError;
